import Component from './component'
import {connect} from 'react-redux'

const MapStateToProps = (state) => ({
    mapaData : state.ui.mapa,
    lotesData : state.database.vendas
})

export default connect(MapStateToProps,  null, null, { withRef: true })(Component)


// WEBPACK FOOTER //
// ./src/views/administrativo/vendas/mapa/container.js